import { Typography } from "antd"
import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import Checkbox from "../../../../../../Components/Checkbox"
import DatePicker from "../../../../../../Components/DatePicker"
import Input from "../../../../../../Components/Input"
import InputNumber from "../../../../../../Components/Input/InputNumber"
import TextArea from "../../../../../../Components/Input/TextArea"
import Select from "../../../../../../Components/Select"

import styles from "./enrichmentField.module.less"

const { Text } = Typography

// One Enrichment field: label + the control matching `field.type`. Disabled
// (read-only value) once the dispute is no longer actionable, same gate the
// Evidence PDF tab's Edit/Regenerate actions already use.
const EnrichmentField = ({ field, value, onChange, disabled }) => {
  const { t } = useTranslation()

  let control = null
  switch (field.type) {
    case "textarea":
      control = (
        <TextArea
          value={value ?? ""}
          placeholder={field.placeholder ? t(field.placeholder) : undefined}
          rows={3}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
      )
      break
    case "number":
      control = (
        <InputNumber
          value={value === "" || value == null ? null : Number(value)}
          min={field.min}
          max={field.max}
          disabled={disabled}
          onChange={(v) => onChange(v === null || v === undefined ? "" : String(v))}
          style={{ width: "100%" }}
        />
      )
      break
    case "select":
      control = (
        <Select
          size="large"
          value={value || undefined}
          placeholder={t("Select an option")}
          options={field.options.map((o) => ({ value: o.value, label: t(o.label) }))}
          disabled={disabled}
          onChange={(v) => onChange(v)}
          allowClear
          style={{ width: "100%" }}
        />
      )
      break
    case "date":
      control = (
        <DatePicker
          value={value ? dayjs(value) : null}
          format="DD MMM YYYY"
          disabled={disabled}
          onChange={(d) => onChange(d ? d.format("YYYY-MM-DD") : "")}
          style={{ width: "100%" }}
        />
      )
      break
    case "boolean":
      control = (
        <Checkbox
          type="bounce"
          checked={!!value}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        >
          <Text>{t(field.label)}</Text>
        </Checkbox>
      )
      break
    default:
      control = (
        <Input
          value={value ?? ""}
          placeholder={field.placeholder ? t(field.placeholder) : undefined}
          disabled={disabled}
          onChange={(e) => onChange(e.target.value)}
        />
      )
  }

  return (
    <div className={styles.field}>
      {field.type !== "boolean" ? <div className={styles.fieldLabel}>{t(field.label)}</div> : null}
      {control}
    </div>
  )
}

export default EnrichmentField
